import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import hive from '@bombas/hive';
import * as Styled from './Breadcrumbs.styled';
import { BreadcrumbsFragment } from './Breadcrumbs.gql';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';

const Breadcrumbs = ({ crumbs, ...props }) => {
  if (!crumbs?.length) return null;
  const { styleQueryMode } = useContext(ContainerQueryContext);

  const handleClick = () => {
    hive.track('PDP_BREADCRUMBS_LINK_CLICK');
  };

  return (
    <Styled.Breadcrumbs {...props}>
      {crumbs.map((crumb) => (
        <Styled.Crumb key={crumb.name} $styleQueryMode={styleQueryMode}>
          <Styled.Link href={crumb.link} onClick={() => handleClick()}>
            {crumb.name}
          </Styled.Link>
        </Styled.Crumb>
      ))}
    </Styled.Breadcrumbs>
  );
};

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  )
};

Breadcrumbs.defaultProps = {
  crumbs: []
};

Breadcrumbs.fragment = BreadcrumbsFragment;

export default Breadcrumbs;
